<template>
  <el-dialog ref="dataView" title="活动数据" :visible.sync="visible" :append-to-body="true" width="68%">
    <el-descriptions column="3" border size="mini">
      <el-descriptions-item label="活动名称">{{ info.activityFirstOrderName }}</el-descriptions-item>
      <el-descriptions-item label="隶属公司">{{ info.merchantName }}</el-descriptions-item>
      <el-descriptions-item label="线路">{{ info.lineName }}</el-descriptions-item>
      <el-descriptions-item label="总订单数"><span class="tip__color">{{ info.orderNum }}</span></el-descriptions-item>
      <el-descriptions-item label="使用优惠数"><span class="tip__color">{{ info.firstOrderNum }}</span></el-descriptions-item>
      <el-descriptions-item label="使用优惠比例"><span class="tip__color">{{ info.ratio }}</span></el-descriptions-item>
      <el-descriptions-item label="优惠金额"><span class="tip__color">{{ info.firstOrderAmount }}</span></el-descriptions-item>
      <el-descriptions-item label="支付金额"><span class="tip__color">{{ info.payAmount }}</span></el-descriptions-item>
    </el-descriptions>

    <div style="padding-top: 18px">
      <el-table :load="loading" border max-height="280px" :data="data" size="mini">
        <el-table-column label="用户账号" align="center" prop="mobilePhone"></el-table-column>
        <el-table-column label="使用时间" align="center" prop="createTime"></el-table-column>
        <el-table-column label="优惠金额" align="center" prop="firstOrderAmount"></el-table-column>
        <el-table-column label="支付金额" align="center" prop="payAmount"></el-table-column>
        <el-table-column label="订单状态" align="center" prop="state">
          <template slot-scope="scope">
            {{ scope.row.state | stateFilter }}
          </template>
        </el-table-column>
        <el-table-column label="使用订单号" align="center" prop="orderNo"></el-table-column>
      </el-table>
      <pagination v-if="page.total > 0" :total="page.total" :page.sync="page.current" :limit.sync="page.size" @pagination="onLoad"></pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="visible = !visible">取 消</el-button>
      <el-button type="primary" size="small" @click="handleExcel">导出</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { detailsViewDataById, dataPage } from '@/api/marketing/activities-api'
  export default {
    name: "activities-data-view",
    filters: {
      stateFilter(state) {
        if (state === 2) return '待支付'
        if (state === 0) return '已支付'
        if (state === 8) return '进行中'
        if (state === 7) return '已完成'
        if (state === 4) return '已取消'
        if (state === 6) return '已退款'
        if (state === 9) return '已改签'
      }
    },
    data() {
      return {
        loading: true,
        visible: false,
        info: {},
        activityFirstOrderId: '',
        page: {
          current: 1,
          size: 10,
          total: 0
        },
        data: []
      }
    },
    methods: {
      init(row) {
        this.visible = true
        this.activityFirstOrderId = row.id
        this.$nextTick(() => {
          detailsViewDataById(row.id).then(resp => {
            this.info = resp.data
          })

          this.onLoad()
        })
      },
      async onLoad() {
        this.loading = true
        const adonData = {
          current: this.page.current,
          size: this.page.size,
          activityFirstOrderId:  this.activityFirstOrderId
        }
        await dataPage(adonData).then(resp => {
          this.loading = false
          this.data = resp.data.records
          this.page.total = resp.data.total
        })
      },
      handleExcel() {
        this.$message.error('数据为空，暂时导不出来')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tip__color {
    color: #1e9fff;
    font-size: 18px;
    font-weight: bold;
  }
</style>
